
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/box",
      function () {
        return require("private-next-pages/destinations/box.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/box"])
      });
    }
  